import React, { Component } from "react";
import DataTable from ".././../../Datatable/DataTable";

class Tablecontent extends Component {
  _isMounted = false;

  state = {
    newData: [],
  };

  componentDidMount() {
    this.setState({
      newData: this.props.newData,
    });
  }
  componentWillReceiveProps(newProps) {
    if (
      JSON.stringify(this.props.newData) !== JSON.stringify(newProps.newData) &&
      newProps.newData.length > 0
    ) {
      this.setState({
        newData: newProps.newData,
      });
    }
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  render() {
    const { newData } = this.state;
    const { tableHeading } = this.props;
    return (
      <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
        {newData.length > 0 ? (
          <DataTable
            data={newData}
            columns={tableHeading}
            paging={true}
            searching={false}
          />
        ) : null}
      </div>
    );
  }
}

export default Tablecontent;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/Component page/LiveHoldings/section2/tablecontent.jsx